import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, CircularProgress } from "@mui/material";
import axios from "../../utils/api";

const UpdateUserSettings = () => {
  const [manualMapping, setManualMapping] = useState("");
  const [objectDisinfection, setObjectDisinfection] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true);
    setSuccessMessage("");
    try {
      const response = await axios.put("/settings/updateAll", {
        manualMapping,
        objectDisinfection,
      });

      setSuccessMessage(response.data.message);
      setManualMapping("");
      setObjectDisinfection("");
    } catch (error) {
      console.error("Error updating user settings:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background:
          "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        padding: "24px 32px 48px",
        boxSizing: "border-box",
      }}
    >
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 56, marginBottom: 32 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Update Metadata for All Users
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Configure manual mapping and object disinfection settings
        </p>
      </div>

      <div
        style={{
          maxWidth: 420,
          margin: "0 auto",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <label
            style={{
              display: "block",
              marginBottom: 8,
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#64748b",
            }}
          >
            Manual Mapping
          </label>
          <select
            value={manualMapping}
            onChange={(e) => setManualMapping(e.target.value)}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "0.75rem 2.25rem 0.75rem 1rem",
              fontSize: "1rem",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              outline: "none",
              backgroundColor: "#fff",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%2364748b' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 0.75rem center",
              backgroundSize: "1.25rem",
              cursor: "pointer",
            }}
          >
            <option value="">Select option</option>
            <option value="enabled">Enabled</option>
            <option value="disabled">Disabled</option>
          </select>
        </div>

        <div style={{ marginBottom: 24 }}>
          <label
            style={{
              display: "block",
              marginBottom: 8,
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#64748b",
            }}
          >
            Object Disinfection
          </label>
          <select
            value={objectDisinfection}
            onChange={(e) => setObjectDisinfection(e.target.value)}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "0.75rem 2.25rem 0.75rem 1rem",
              fontSize: "1rem",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              outline: "none",
              backgroundColor: "#fff",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%2364748b' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 0.75rem center",
              backgroundSize: "1.25rem",
              cursor: "pointer",
            }}
          >
            <option value="">Select option</option>
            <option value="enabled">Enabled</option>
            <option value="disabled">Disabled</option>
          </select>
        </div>

        {loading && (
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
            <CircularProgress size={28} sx={{ color: "#667eea" }} />
          </div>
        )}

        {successMessage && (
          <p
            style={{
              margin: "0 0 16px",
              color: "#16a34a",
              fontSize: "0.9rem",
              fontWeight: 500,
            }}
          >
            {successMessage}
          </p>
        )}

        <button
          onClick={handleSubmit}
          disabled={loading}
          style={{
            width: "100%",
            padding: "0.75rem 1rem",
            fontSize: "1rem",
            fontWeight: 600,
            background: loading ? "#94a3b8" : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: loading ? "not-allowed" : "pointer",
            boxShadow: loading ? "none" : "0 2px 8px rgba(102, 126, 234, 0.3)",
            transition: "opacity 0.2s",
          }}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default UpdateUserSettings;
